/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactScriptManifest } from './ContactScriptManifest.js';
import {
    ContactScriptManifestFromJSON,
    ContactScriptManifestFromJSONTyped,
    ContactScriptManifestToJSON,
} from './ContactScriptManifest.js';

/**
 * 
 * @export
 * @interface GetContactScriptResponse
 */
export interface GetContactScriptResponse {
    /**
     * 
     * @type {ContactScriptManifest}
     * @memberof GetContactScriptResponse
     */
    data?: ContactScriptManifest;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactScriptResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactScriptResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactScriptResponse interface.
 */
export function instanceOfGetContactScriptResponse(value: object): boolean {
    return true;
}

export function GetContactScriptResponseFromJSON(json: any): GetContactScriptResponse {
    return GetContactScriptResponseFromJSONTyped(json, false);
}

export function GetContactScriptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactScriptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactScriptManifestFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactScriptResponseToJSON(value?: GetContactScriptResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactScriptManifestToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

